// Components==============
import {
    faHandPointer,
    faPhone,
    faSchool,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import school from 'actions/school';
import React, { useContext, useEffect, useRef } from 'react';
import { OverOrionContext } from 'screens/OverOrion';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import Button from 'components/UI/Button';
import Location from '../Location';
import './index.module.scss';
// =========================

const Contact = ({ contact }) => (
    <div styleName="contact">
        {contact?.street && (
            <div styleName="grid">
                <FontAwesomeIcon icon={faSchool} />
                <p>
                    {`${contact.street} `}
                    <br />
                    {`${contact?.postal_code} ${contact?.city}`}
                </p>
            </div>
        )}
        {contact?.phone && (
            <div styleName="grid">
                <FontAwesomeIcon icon={faPhone} />
                <p>{contact.phone}</p>
            </div>
        )}
        {contact?.website && (
            <div styleName="grid">
                <FontAwesomeIcon icon={faHandPointer} />

                <a
                    href={
                        contact.website && contact.website.includes('http')
                            ? contact.website
                            : `https://${contact.website}`
                    }
                    target="_blank"
                    rel="noreferrer"
                >
                    {contact.website}
                </a>
            </div>
        )}
    </div>
);

export default function Card({
    image,
    name,
    contact,
    index,
    subDivisions,
    logo,
    id,
    popup,
}) {
    const { selected } = useContext(OverOrionContext);

    const subDivisionIndexes = subDivisions?.map((e) => e?.index);
    const active = selected === index || subDivisionIndexes?.includes(selected);

    const ref = useRef();

    useEffect(() => {
        if (active)
            window?.scrollTo({
                top: ref?.current?.offsetTop - 100,
            });
    }, [selected]);

    const hasPopup = popup && popup.length > 0;
    const slug = `popup-${id}`;
    const openModal = useOpenUrlModal(slug);

    return (
        <>
            <div
                styleName="card"
                style={{
                    border: active ? '#1e265c 3px solid' : 'none',
                    cursor: popup ? 'pointer' : 'auto',
                }}
                ref={ref}
            >
                <img src={image} alt={name} styleName="header" />
                <div styleName="content">
                    <h2 styleName="school-name">{name}</h2>
                    {subDivisions && subDivisions.length > 0 ? (
                        <div styleName="sub">
                            {subDivisions.map((e, i) => {
                                const division = e;

                                return (
                                    <div key={e?.key}>
                                        <div styleName="title-grid">
                                            <Location index={e?.index} />
                                            <h3>{division.name}</h3>
                                        </div>
                                        <Contact
                                            contact={{
                                                street: division?.street,
                                                postal_code:
                                                    division?.postal_code,
                                                city: division?.city,
                                                phone: division?.phone,
                                                website: division?.website,
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <>
                            <Contact contact={contact} />
                        </>
                    )}
                    {hasPopup && (
                        <div styleName="button">
                            <Button
                                style={{ fontSize: '10px' }}
                                onClick={() => (hasPopup ? openModal() : null)}
                            >
                                Wat onze school bijzonder maakt
                            </Button>
                        </div>
                    )}
                    <div styleName="bottom">
                        <img src={logo} alt={name} />
                        {index && <Location index={index} />}
                    </div>
                </div>
            </div>
            {hasPopup ? (
                <Modal slug={slug}>
                    <div styleName="popup-wrapper">
                        <RichText richText={popup} />
                    </div>
                </Modal>
            ) : null}
        </>
    );
}
